import { faFileExcel, faFileZipper } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Container } from 'react-bootstrap';
import { EarthGraphyFooter } from './EarthGraphyFooter';
import { EarthGraphyNavbar } from './EarthGraphyNavbar';
import { RSCatalog } from './RSCatalog';
import styles from './RSCatalogScreen.module.css';

type Props = {
  catalog_url: string;
  docs_url: string;
};

export const RSCatalogScreen = ({ catalog_url, docs_url }: Props) => (
  <>
    <EarthGraphyNavbar />

    <header className={`${styles.headerBackground} mb-3`}>
      <Container>
        <h1 className="display-4">リモートセンシングデータカタログ</h1>
        <p className="lead">
          リモートセンシングデータ活用を検討中の方を対象に、どのようなデータが利用可能かわかりやすく整理しました。
        </p>
        <ul className="list-inline">
          <li className="list-inline-item">
            <Button href={catalog_url} variant="outline-primary">
              <FontAwesomeIcon icon={faFileExcel} /> カタログをダウンロード
            </Button>
          </li>
          <li className="list-inline-item">
            <Button href={docs_url} variant="outline-secondary">
              <FontAwesomeIcon icon={faFileZipper} /> 参考資料をダウンロード
            </Button>
          </li>
        </ul>
      </Container>
    </header>

    <Container as="main" className="mb-3">
      <RSCatalog />
    </Container>

    <EarthGraphyFooter />
  </>
);
